import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { IntegrationFormComponent } from '../integration-form/integration-form.component';

@Component({
  imports: [
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './integration-list.page.html',
  styleUrl: './integration-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class IntegrationListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);
  private router = inject(Router);

  public url = Urls.urls.integrations;

  public headers = [
    { name: 'NOMBRE', key: 'name' },
    { name: 'TIENDA', key: 'store_url' },
    { name: 'ACTIVA', key: 'enabled', type: 'boolean' },
    { name: 'ÚLTIMO ERROR', key: 'last_error' },
  ];

  openCreateForm() {
    const modalRef = this.sauModalService.open(IntegrationFormComponent, {});
    modalRef.componentInstance.id = 0;

    modalRef.componentInstance.acceptFunction.subscribe((integration: any) => {
      if (integration?.id) {
        this.router.navigate(['/integrations', integration.id]);
      } else {
        this.sauTable?.getItems();
      }
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDetail(item: { id: number }) {
    this.router.navigate(['/integrations', item.id]);
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'integración';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
